import PropTypes from 'prop-types'
import useAuth from '@/hooks/useAuth'
import { SCHOOL_FLAVOUR } from '@/lib/terminology'
import FeatureUnavailable from '@/pages/FeatureUnavailable'

/**
 * Blocks a route unless the active organisation's flavour is one of
 * `allowedFlavours`. Fail-closed: an unknown/missing flavour resolves to
 * `SCHOOL_FLAVOUR` (mirroring `nav-access.js`), so the route is blocked
 * unless 'school' is explicitly allowed.
 */
const FlavourGuard = ({ allowedFlavours, children }) => {
    const { activeOrg } = useAuth()
    const flavour = activeOrg?.flavour || SCHOOL_FLAVOUR

    if (!allowedFlavours?.includes(flavour)) {
        return <FeatureUnavailable />
    }

    return <>{children}</>
}

FlavourGuard.propTypes = {
    allowedFlavours: PropTypes.arrayOf(PropTypes.string).isRequired,
    children: PropTypes.node
}

export default FlavourGuard
